<script>
import InicioNegocioComponent from '@/components/InicioNegocioComponent.vue';
export default InicioNegocioComponent;
</script>
